import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateDistributionType extends Enum {
  key!: string;
  value!: string;

  static SPECIFIC = {
    key: 'specific',
    get value(): string {
      return Lang.t('estatedistribution.specific');
    }
  };

  static RESIDUAL = {
    key: 'residual',
    get value(): string {
      return Lang.t('estatedistribution.residual');
    }
  };
}
